import type { StudioForm } from '../studio/studio-api';
import { objectKind, reelsPolicy, reelsSupported } from './reels-policy';

export { reelsSupported };

const uploadId = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** «Загрузите фото товара», «Загрузите 3 фото», «Загрузите ещё 1 фото товара» (APP-SPEC-5 §8.2). */
export function photoNeedText(have: number, min: number, of: string) {
  const what = (n: number) => `${n > 1 || have ? `${n} ` : ''}фото${of ? ` ${of}` : ''}`;
  return have ? `Загрузите ещё ${what(min - have)}` : `Загрузите ${what(min)}`;
}

/** Проверки полей формы: права, загрузки, сценарий. Роли и шаблоны набора проверяет экран (reels-cast). */
export function reelsMissing(form: StudioForm, inputs: Record<string, string>, rights: boolean): string | null {
  if (!reelsSupported(form)) return 'Этот вариант рилса пока недоступен';
  if (form.fields.some(field => field.upload && (field.required || inputs[field.key])) && !rights) return 'Подтвердите права на фото';
  const policy = reelsPolicy(form);
  const groups = new Map<string, { have: number; min: number }>();
  for (const field of form.fields) {
    const value = inputs[field.key] ?? '';
    if (field.upload) {
      if (value && !uploadId.test(value)) return 'Проверьте загрузку фото';
      const kind = objectKind(field.key);
      const group = groups.get(kind) ?? { have: 0, min: 0 };
      groups.set(kind, { have: group.have + (value ? 1 : 0), min: group.min + (field.required ? 1 : 0) });
      continue;
    }
    if (field.key === 'text') {
      if (field.required && !value.trim()) return 'Добавьте сценарий';
      // The published form declares UTF-16, matching the server validation.
      if (value.length > (field.max_length ?? 1000)) return 'Сократите сценарий';
    }
  }
  for (const [kind, group] of groups)
    if (group.have < group.min) return photoNeedText(group.have, group.min, policy.needs[kind]?.of || { goods: 'товара', food: 'блюда', place: 'места' }[kind] || '');
  return null;
}
